import { IEssayBody } from '../../../core/models/essay';
import { sendEssay } from '../../../core/queries/essays-queries/essayFunction';
import { useMutation } from '@tanstack/react-query';

export function useSendPracticeEssay() {
  const { mutate, isPending, isError, isSuccess } = useMutation({
    mutationKey: ['sendPracticeEssay'], 
    mutationFn: (body: IEssayBody) => sendEssay(body),
    retry: false
  });

  return { mutate, isPending, isError, isSuccess };
}